/* prettier-ignore-file */
import React from "react";
import { View, Text, TextInput, StyleSheet } from "react-native";

const EditableSection = ({ 
  label, 
  value, 
  onChange, 
  hint, 
  variables = [], 
  multiline = false,
  placeholder = ""
}) => {
  return (
    <View style={styles.container}>
      <Text style={styles.label}>{label}</Text>
      {hint && <Text style={styles.hint}>{hint}</Text>}
      
      <TextInput
        style={[styles.input, multiline && styles.multilineInput]}
        value={value}
        onChangeText={onChange}
        placeholder={placeholder}
        placeholderTextColor="#AEB8B6"
        multiline={multiline}
        numberOfLines={multiline ? 4 : 1}
      />
      
      {variables.length > 0 && (
        <View style={styles.variablesContainer}>
          <Text style={styles.variablesLabel}>Available variables:</Text>
          <View style={styles.variablesList}>
            {variables.map((variable, index) => (
              <View key={index} style={styles.variableTag}>
                <Text style={styles.variableText}>{variable}</Text>
              </View>
            ))}
          </View>
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginBottom: 25,
    backgroundColor: "#FFFFFF",
    padding: 15,
    borderRadius: 6,
    borderWidth: 1,
    borderColor: "#DDE3E2",
  },
  label: {
    fontSize: 16,
    fontWeight: "600",
    color: "#2E3A38",
    marginBottom: 6,
  },
  hint: {
    fontSize: 13,
    color: "#5C6B68",
    marginBottom: 10,
    fontStyle: "italic",
  },
  input: {
    borderWidth: 1,
    borderColor: "#DDE3E2",
    borderRadius: 5,
    padding: 12,
    fontSize: 14,
    color: "#2E3A38",
    backgroundColor: "#F4F6F6",
  },
  multilineInput: {
    minHeight: 100,
    textAlignVertical: "top",
  },
  variablesContainer: {
    marginTop: 10,
    padding: 10,
    backgroundColor: "#E3F2EF",
    borderRadius: 5,
    borderLeftWidth: 3,
    borderLeftColor: "#0E7C6B",
  },
  variablesLabel: {
    fontSize: 12,
    color: "#5C6B68",
    marginBottom: 8,
    fontWeight: "500",
  },
  variablesList: {
    flexDirection: "row",
    flexWrap: "wrap",
    gap: 6,
  },
  variableTag: {
    backgroundColor: "#0E7C6B",
    paddingHorizontal: 10,
    paddingVertical: 4,
    borderRadius: 8,
    marginRight: 6,
    marginBottom: 6,
  },
  variableText: {
    fontSize: 11,
    color: "#FFFFFF",
    fontFamily: "monospace",
    fontWeight: "600",
  },
});

export default EditableSection;

